import {ModelInterface} from "../../data-structures/collection";
import {NavigationButtonPosition, NavigationSectionConfig, ScrollToInMenu} from "../navigation/@const";
import NavigationSection from "../navigation/navigation-section";
import {BUS_SHOW_IN_MENU} from "../../../layout/menu/@events";
import {ProjectsTreeSortType} from "../../../layout/menu/components/space-preferences/preferences";
import ProjectSession from "../project/project-session";
import StarredItem from "../starred/starred-item";


export class SpaceProto implements ModelInterface {

    public id               : ID
    public navigation!      : NavigationSection
    public positionOptions  : NavigationButtonPosition[] = [NavigationButtonPosition.TOP, NavigationButtonPosition.MORE]
    public title            : string    = "Space"
    public canHaveProjects  : boolean   = false     // if true this space can have projects
    public icon             : string    = 'i5-structure-1'
    public svgIcon?         : string    = undefined     // optional - only system spaces have it ?

    constructor(id : ID) {
        this.id = id
    }

    // Ne vsegda nujen GroupedData. Na primer chats. Type ukazivaem v dochernix classax
    search(keyword:string): any {
        throw Error("0328387r444 Not implemented")
    }

    get hasSearch(): boolean {
        return true
    }

    get projectsColorize():boolean {
        return gd.user.settings.navigation.spacesPreferences[this.id]?.projectsColorize || false
    }

    set projectsColorize(projectsColorize: boolean) {
        if (!gd.user.settings.navigation.spacesPreferences[this.id]) gd.user.settings.navigation.spacesPreferences[this.id] = {}
        gd.user.settings.navigation.spacesPreferences[this.id].projectsColorize = projectsColorize
        gd.user.settings.save()
    }

    set projectsSorting(projectsSorting: ProjectsTreeSortType) {
        if (!gd.user.settings.navigation.spacesPreferences[this.id]) gd.user.settings.navigation.spacesPreferences[this.id] = {}
        gd.user.settings.navigation.spacesPreferences[this.id].projectsSorting = projectsSorting
        gd.user.settings.save()
    }

    get projectsSorting():ProjectsTreeSortType {
        return gd.user.settings.navigation.spacesPreferences[this.id]?.projectsSorting || ProjectsTreeSortType.ALPHABETICAL
    }

    // reset manual sorting
    resetSortedMap() {
        const id = this.id === 'projects' ? 'root' : this.id

        delete gd.user.menu.projectsAll.sortedMap[id]
        gd.user.menu.save()

        // delete gd.user.settings.navigation.spacesPreferences[this.id]?.sortedMap
        // gd.user.settings.save()
    }

    async openMenu(scrollTo?:ScrollToInMenu) {

        await gd.layout.navigation.openSectionV2(this.navigation)

        scrollTo && gd.bus.triggerEvent(BUS_SHOW_IN_MENU, scrollTo)

        return true
    }

    get isWorkspace(): boolean {
        return false
    }

    get enabled(): boolean {
        return true
    }

    get inNavigationPanel():boolean {

        if (!this.navigation) {

            // HAPPENS WHEN CHATS NOT THERE
            if (this.id === 'chats') {
                return false
            }

            // projects - happens when no space projects
            if (this.id === 'projects') {
                return false
            }


            // happens when no chat enabled or space is in more
            // console.error("#kkdjdjd-3 how come no navigation ?")
            // console.log("No navigation for space ", this.id)

            return false
        }

        return this.enabled && this.navigation.position === NavigationButtonPosition.TOP
    }

    get inNavigationMore():boolean {
        return this.navigation?.position === NavigationButtonPosition.MORE
    }

    get navigationStructureConfig():NavigationSectionConfig {
        throw Error("#ld9238djs not implemented")
    }

    get rootProjects():ProjectSession[] {
        throw Error("#ksnm230 not implemented")
    }

    get starredProjects():ProjectSession[] {

        const projects  : ProjectSession[] = []

        // gd.session.starredItems.getProjectStarredItem()
        _.map(gd.session.starredItems.models, (starredItem:StarredItem)=>{


            if (starredItem.space?.id === this.id) {

                const project : ProjectSession | null = gd.session.projects.get(starredItem.projectId)
                if (project) {
                    projects.push(project)
                }
            }
        })

        return projects
    }


    initNavigation() {

        if (!this.enabled) return

        this.navigation         = new NavigationSection(this.navigationStructureConfig)
        this.navigation.space   = this
        gd.navigationStructure.add(this.navigation)
    }

    removeNavigation() {
        if (this.navigation) {
            gd.navigationStructure.remove(this.navigation.id)
        }
    }

    toJSON() {
        throw Error("#90d82kkk not implemented")
    }


}
